define("checkout/components/seamless-checkout/checkout-success-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _isIntervalDowngrade, _isIntervalUpgrade, _subscriptionPlanToCompare, _isPlanDowngrade, _isPlanUpgrade, _isAiCreditsDowngrade, _isAiCreditsUpgrade, _isSocialSetDowngrade, _isSocialSetUpgrade, _isUserDowngrade, _isUserUpgrade, _showAddonChanges, _upcomingAiCreditsChange, _upcomingSocialSetChange, _upcomingUserChange, _downgradeMap, _addonUpgradeMap;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
  function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{this.close}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}} class="has--footer">
      <modal.card-header class="u--p__b">
        <h1 class="o--modalHeader__title">
          {{#if this.hasActiveTrial}}
            {{t "plans.checkout.trial_success.title"}}
          {{else if this.showUpgradeSuccess}}
            {{t "checkout.success_modal_upgrade.title" planName=this.newPlanName}}
          {{else}}
            {{t "checkout.success_modal_update.title"}}
          {{/if}}
        </h1>
      </modal.card-header>
      <modal.card-body>
        <div>
          <p class="u--text--md u--m__b">
            {{#if this.hasActiveTrial}}
              {{html-safe
                (t
                  (if
                    this.isSourcelessTrialABTest
                    "plans.checkout.trial_success.auto_trial_sub_title"
                    "plans.checkout.trial_success.sub_title"
                  )
                  planName=this.newPlanName
                  interval=this.newIntervalName
                  expiryDate=(moment-format this.currentAccount.trialExpiryMoment "MMM DD, YYYY")
                )
              }}
            {{else if this.showUpgradeSuccess}}
              {{html-safe
                (t
                  "checkout.success_modal_upgrade.sub_title"
                  planName=this.newPlanName
                  interval=this.newIntervalName
                  date=this.renewalDate
                )
              }}
            {{else}}
              {{! NOTE: also handles manage account..  }}
              <p data-test-id="downgraded">
                {{this.upgradeAddonsSummary}}
                {{this.downgradeSummary}}
              </p>
            {{/if}}
          </p>
          {{#if this.hasEnteredValidTaxId}}
            <p class="u--text--md u--text--italic u--text--light u--m__b">
              {{#if this.hasActiveTrial}}
                {{t "checkout.success_modal.vat_pending_trial"}}
              {{else}}
                {{t "checkout.success_modal.vat_pending"}}
              {{/if}}
            </p>
          {{/if}}
        </div>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @additional="block"
          @onClick={{this.close}}
          @size="large"
          @text={{t "shared_words.ok"}}
          type="submit"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "CVYADY7H",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@focusTrap\"],[[30,0,[\"close\"]],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"has--footer\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h1\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"          \"],[1,[28,[35,2],[\"plans.checkout.trial_success.title\"],null]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showUpgradeSuccess\"]],[[[1,\"          \"],[1,[28,[35,2],[\"checkout.success_modal_upgrade.title\"],[[\"planName\"],[[30,0,[\"newPlanName\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,2],[\"checkout.success_modal_update.title\"],null]],[1,\"\\n        \"]],[]]]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md u--m__b\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"            \"],[1,[28,[35,3],[[28,[37,2],[[52,[30,0,[\"isSourcelessTrialABTest\"]],\"plans.checkout.trial_success.auto_trial_sub_title\",\"plans.checkout.trial_success.sub_title\"]],[[\"planName\",\"interval\",\"expiryDate\"],[[30,0,[\"newPlanName\"]],[30,0,[\"newIntervalName\"]],[28,[37,4],[[30,0,[\"currentAccount\",\"trialExpiryMoment\"]],\"MMM DD, YYYY\"],null]]]]],null]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showUpgradeSuccess\"]],[[[1,\"            \"],[1,[28,[35,3],[[28,[37,2],[\"checkout.success_modal_upgrade.sub_title\"],[[\"planName\",\"interval\",\"date\"],[[30,0,[\"newPlanName\"]],[30,0,[\"newIntervalName\"]],[30,0,[\"renewalDate\"]]]]]],null]],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,2],[14,\"data-test-id\",\"downgraded\"],[12],[1,\"\\n              \"],[1,[30,0,[\"upgradeAddonsSummary\"]]],[1,\"\\n              \"],[1,[30,0,[\"downgradeSummary\"]]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]],[]]],[1,\"        \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasEnteredValidTaxId\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--md u--text--italic u--text--light u--m__b\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"              \"],[1,[28,[35,2],[\"checkout.success_modal.vat_pending_trial\"],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,2],[\"checkout.success_modal.vat_pending\"],null]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,5],[[24,4,\"submit\"]],[[\"@additional\",\"@onClick\",\"@size\",\"@text\"],[\"block\",[30,0,[\"close\"]],\"large\",[28,[37,2],[\"shared_words.ok\"],null]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\"],false,[\"shared/modal\",\"if\",\"t\",\"html-safe\",\"moment-format\",\"shared/ui/button\"]]",
    "moduleName": "checkout/components/seamless-checkout/checkout-success-modal.hbs",
    "isStrictMode": false
  });
  let CheckoutSuccessModalComponent = _exports.default = (_class = (_isIntervalDowngrade = /*#__PURE__*/new WeakMap(), _isIntervalUpgrade = /*#__PURE__*/new WeakMap(), _subscriptionPlanToCompare = /*#__PURE__*/new WeakMap(), _isPlanDowngrade = /*#__PURE__*/new WeakMap(), _isPlanUpgrade = /*#__PURE__*/new WeakMap(), _isAiCreditsDowngrade = /*#__PURE__*/new WeakMap(), _isAiCreditsUpgrade = /*#__PURE__*/new WeakMap(), _isSocialSetDowngrade = /*#__PURE__*/new WeakMap(), _isSocialSetUpgrade = /*#__PURE__*/new WeakMap(), _isUserDowngrade = /*#__PURE__*/new WeakMap(), _isUserUpgrade = /*#__PURE__*/new WeakMap(), _showAddonChanges = /*#__PURE__*/new WeakMap(), _upcomingAiCreditsChange = /*#__PURE__*/new WeakMap(), _upcomingSocialSetChange = /*#__PURE__*/new WeakMap(), _upcomingUserChange = /*#__PURE__*/new WeakMap(), _downgradeMap = /*#__PURE__*/new WeakMap(), _addonUpgradeMap = /*#__PURE__*/new WeakMap(), class CheckoutSuccessModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateFieldInitSpec(this, _addonUpgradeMap, {
        get: _get_addonUpgradeMap,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _downgradeMap, {
        get: _get_downgradeMap,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _upcomingUserChange, {
        get: _get_upcomingUserChange,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _upcomingSocialSetChange, {
        get: _get_upcomingSocialSetChange,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _upcomingAiCreditsChange, {
        get: _get_upcomingAiCreditsChange,
        set: void 0
      });
      /**
       * Note: we hide addon changes if we are restoring addons to simplify scope of the dynamic messages.
       *
       * Example: User is making changes to the upcoming downgrade of addons.
       */
      _classPrivateFieldInitSpec(this, _showAddonChanges, {
        get: _get_showAddonChanges,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isUserUpgrade, {
        get: _get_isUserUpgrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isUserDowngrade, {
        get: _get_isUserDowngrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isSocialSetUpgrade, {
        get: _get_isSocialSetUpgrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isSocialSetDowngrade, {
        get: _get_isSocialSetDowngrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isAiCreditsUpgrade, {
        get: _get_isAiCreditsUpgrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isAiCreditsDowngrade, {
        get: _get_isAiCreditsDowngrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isPlanUpgrade, {
        get: _get_isPlanUpgrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isPlanDowngrade, {
        get: _get_isPlanDowngrade,
        set: void 0
      });
      /**
       * The user's chosen plan after checkout is successful.
       */
      _classPrivateFieldInitSpec(this, _subscriptionPlanToCompare, {
        get: _get_subscriptionPlanToCompare,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isIntervalUpgrade, {
        get: _get_isIntervalUpgrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _isIntervalDowngrade, {
        get: _get_isIntervalDowngrade,
        set: void 0
      });
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "auth", _descriptor3, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor4, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _defineProperty(this, "hasEnteredValidTaxId", false);
      this.hasEnteredValidTaxId = this.cache.retrieve('hasEnteredValidTaxId') ?? false;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get newIntervalName() {
      return _classPrivateFieldGet(this, _subscriptionPlanToCompare)?.intervalName;
    }
    get newPlanName() {
      return _classPrivateFieldGet(this, _subscriptionPlanToCompare)?.displayName;
    }
    get currentSubscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }
    get upcomingSubscriptionPlan() {
      return this.subscriptions.upcomingSubscriptionPlan;
    }
    get hasActiveTrial() {
      return this.auth.currentAccount?.hasActiveTrial;
    }
    get isSourcelessTrialABTest() {
      return this.auth.currentAccount?.rolloutSourcelessTrial;
    }
    get renewalDate() {
      return this.subscriptions.subscription?.renewalDate;
    }
    get showUpgradeSuccess() {
      return _classPrivateFieldGet(this, _isPlanUpgrade) || _classPrivateFieldGet(this, _isIntervalUpgrade);
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get downgradeSummary() {
      if (!this.upcomingSubscriptionPlan || !this.subscription) {
        return '';
      }
      const interval = this.newIntervalName;
      const date = this.subscription.activeUntil;

      //Note: we assume all addons are changing at the same date.
      const addonDowngradeDateMoment = this.subscription.upcomingSocialSetChanges?.activeAtMoment || this.subscription.upcomingUserChanges?.activeAtMoment || this.subscription.upcomingAiCreditsChanges?.activeAtMoment;
      const addonDowngradeDate = addonDowngradeDateMoment ? addonDowngradeDateMoment.format('MMM D, YYYY') : '';
      const planName = this.newPlanName;
      if (_classPrivateFieldGet(this, _showAddonChanges)) {
        if (_classPrivateFieldGet(this, _isPlanDowngrade)) {
          if (_classPrivateFieldGet(this, _downgradeMap).length === 3) {
            return this.intl.t('checkout.success_modal_update.sub_title.plan_three_addons', {
              date,
              interval,
              planName,
              firstAddon: _classPrivateFieldGet(this, _downgradeMap)[0],
              secondAddon: _classPrivateFieldGet(this, _downgradeMap)[1],
              thirdAddon: _classPrivateFieldGet(this, _downgradeMap)[2]
            });
          } else if (_classPrivateFieldGet(this, _downgradeMap).length === 2) {
            return this.intl.t('checkout.success_modal_update.sub_title.plan_addons', {
              date,
              interval,
              planName,
              firstAddon: _classPrivateFieldGet(this, _downgradeMap)[0],
              secondAddon: _classPrivateFieldGet(this, _downgradeMap)[1]
            });
          } else if (_classPrivateFieldGet(this, _downgradeMap).length === 1) {
            return this.intl.t('checkout.success_modal_update.sub_title.plan_addon', {
              date,
              interval,
              planName,
              addon: _classPrivateFieldGet(this, _downgradeMap)[0]
            });
          }
        } else if (_classPrivateFieldGet(this, _isIntervalDowngrade)) {
          if (_classPrivateFieldGet(this, _downgradeMap).length === 3) {
            return this.intl.t('checkout.success_modal_update.sub_title.interval_three_addon', {
              date,
              interval,
              firstAddon: _classPrivateFieldGet(this, _downgradeMap)[0],
              secondAddon: _classPrivateFieldGet(this, _downgradeMap)[1],
              thirdAddon: _classPrivateFieldGet(this, _downgradeMap)[2]
            });
          } else if (_classPrivateFieldGet(this, _downgradeMap).length === 2) {
            return this.intl.t('checkout.success_modal_update.sub_title.interval_addons', {
              date,
              planName,
              firstAddon: _classPrivateFieldGet(this, _downgradeMap)[0],
              secondAddon: _classPrivateFieldGet(this, _downgradeMap)[1]
            });
          } else if (_classPrivateFieldGet(this, _downgradeMap).length === 1) {
            return this.intl.t('checkout.success_modal_update.sub_title.interval_addon', {
              date,
              addon: _classPrivateFieldGet(this, _downgradeMap)[0]
            });
          }
        }
        if (_classPrivateFieldGet(this, _downgradeMap).length === 3) {
          return this.intl.t('checkout.success_modal_update.sub_title.three_addons', {
            date: addonDowngradeDate,
            interval,
            planName,
            firstAddon: _classPrivateFieldGet(this, _downgradeMap)[0],
            secondAddon: _classPrivateFieldGet(this, _downgradeMap)[1],
            thirdAddon: _classPrivateFieldGet(this, _downgradeMap)[2]
          });
        } else if (_classPrivateFieldGet(this, _downgradeMap).length === 2) {
          return this.intl.t('checkout.success_modal_update.sub_title.addons', {
            date: addonDowngradeDate,
            interval,
            planName,
            firstAddon: _classPrivateFieldGet(this, _downgradeMap)[0],
            secondAddon: _classPrivateFieldGet(this, _downgradeMap)[1]
          });
        } else if (_classPrivateFieldGet(this, _downgradeMap).length === 1) {
          return this.intl.t('checkout.success_modal_update.sub_title.addon', {
            date: addonDowngradeDate,
            interval,
            planName,
            addon: _classPrivateFieldGet(this, _downgradeMap)[0]
          });
        }
      }
      if (_classPrivateFieldGet(this, _isPlanDowngrade)) {
        return this.intl.t('checkout.success_modal_update.sub_title.plan', {
          date,
          interval,
          planName
        });
      } else if (_classPrivateFieldGet(this, _isIntervalDowngrade)) {
        return this.intl.t('checkout.success_modal_update.sub_title.interval', {
          date
        });
      }
      return '';
    }
    get upgradeAddonsSummary() {
      if (!_classPrivateFieldGet(this, _showAddonChanges)) {
        return '';
      }
      if (_classPrivateFieldGet(this, _addonUpgradeMap).length === 3) {
        return this.intl.t('checkout.success_modal.three_addons', {
          firstAddon: _classPrivateFieldGet(this, _addonUpgradeMap)[0],
          secondAddon: _classPrivateFieldGet(this, _addonUpgradeMap)[1],
          thirdAddon: _classPrivateFieldGet(this, _addonUpgradeMap)[2]
        });
      } else if (_classPrivateFieldGet(this, _addonUpgradeMap).length === 2) {
        return this.intl.t('checkout.success_modal.addons', {
          firstAddon: _classPrivateFieldGet(this, _addonUpgradeMap)[0],
          secondAddon: _classPrivateFieldGet(this, _addonUpgradeMap)[1]
        });
      } else if (_classPrivateFieldGet(this, _addonUpgradeMap).length === 1) {
        return this.intl.t('checkout.success_modal.addon', {
          addon: _classPrivateFieldGet(this, _addonUpgradeMap)[0]
        });
      }
      return '';
    }
    close() {
      this.seamlessCheckoutManager.onSuccessModalClose?.();
      this.seamlessCheckoutManager.closeModal();
      if (this.hasActiveTrial) {
        // Note: for triggering appcues tour
        this.segment.track('closed-trial-success-modal');
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "close", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype)), _class);
  function _get_isIntervalDowngrade() {
    const previousInterval = this.seamlessCheckoutManager.lastCheckoutInitialState.interval;
    return previousInterval === 'yearly' && this.upcomingSubscriptionPlan?.interval === 'monthly';
  }
  function _get_isIntervalUpgrade() {
    if (this.subscriptions.hasUpcomingDowngrade) {
      return false;
    }
    const previousInterval = this.seamlessCheckoutManager.lastCheckoutInitialState.interval;
    return previousInterval === 'monthly' && _classPrivateFieldGet(this, _subscriptionPlanToCompare)?.interval === 'yearly';
  }
  function _get_subscriptionPlanToCompare() {
    return this.subscription?.hasUpcomingPlanChanges ? this.upcomingSubscriptionPlan : this.currentSubscriptionPlan;
  }
  function _get_isPlanDowngrade() {
    return this.subscriptions.hasUpcomingDowngrade;
  }
  function _get_isPlanUpgrade() {
    if (this.subscriptions.hasUpcomingDowngrade) {
      return false;
    }
    const previousPlanType = this.seamlessCheckoutManager.lastCheckoutInitialState.planType;
    return previousPlanType != this.currentSubscriptionPlan?.planType;
  }
  function _get_isAiCreditsDowngrade() {
    return _classPrivateFieldGet(this, _upcomingAiCreditsChange) < 0;
  }
  function _get_isAiCreditsUpgrade() {
    return _classPrivateFieldGet(this, _upcomingAiCreditsChange) > 0;
  }
  function _get_isSocialSetDowngrade() {
    return _classPrivateFieldGet(this, _upcomingSocialSetChange) < 0;
  }
  function _get_isSocialSetUpgrade() {
    return _classPrivateFieldGet(this, _upcomingSocialSetChange) > 0;
  }
  function _get_isUserDowngrade() {
    return _classPrivateFieldGet(this, _upcomingUserChange) < 0;
  }
  function _get_isUserUpgrade() {
    return _classPrivateFieldGet(this, _upcomingUserChange) > 0;
  }
  function _get_showAddonChanges() {
    const isUserRestoreAddons = _classPrivateFieldGet(this, _isUserUpgrade) && Boolean(this.seamlessCheckoutManager.lastCheckoutInitialState?.hasUpcomingUserDowngrade);
    const isSocialSetRestoreAddons = _classPrivateFieldGet(this, _isSocialSetUpgrade) && Boolean(this.seamlessCheckoutManager.lastCheckoutInitialState?.hasUpcomingSocialSetDowngrade);
    const isAiCreditsRestoreAddons = _classPrivateFieldGet(this, _isAiCreditsUpgrade) && Boolean(this.seamlessCheckoutManager.lastCheckoutInitialState?.hasUpcomingAiCreditsDowngrade);
    return !isUserRestoreAddons && !isSocialSetRestoreAddons && !isAiCreditsRestoreAddons;
  }
  function _get_upcomingAiCreditsChange() {
    if (!this.subscription) {
      return 0;
    }
    const initialAiCreditsCount = this.seamlessCheckoutManager.lastCheckoutInitialState.aiCreditsCount || 0;
    return this.subscription.upcomingAdditionalAiCredits - initialAiCreditsCount;
  }
  function _get_upcomingSocialSetChange() {
    if (!this.subscription) {
      return 0;
    }
    const initialSocialSetCount = this.seamlessCheckoutManager.lastCheckoutInitialState.socialSetCount || 0;
    return this.subscription.upcomingAdditionalSocialSets - initialSocialSetCount;
  }
  function _get_upcomingUserChange() {
    if (!this.subscription) {
      return 0;
    }
    const initialTeamMemberCount = this.seamlessCheckoutManager.lastCheckoutInitialState.teamMemberCount || 0;
    return this.subscription.upcomingAdditionalUsers - initialTeamMemberCount;
  }
  function _get_downgradeMap() {
    const aiCreditsDowngradeText = this.intl.t('checkout.success_modal_update.amount_extra_ai_credits', {
      amount: Math.abs(_classPrivateFieldGet(this, _upcomingAiCreditsChange) ?? 0)
    });
    const amountExtraSocialSetsText = this.intl.t('checkout.success_modal_update.amount_extra_social_sets', {
      amount: Math.abs(_classPrivateFieldGet(this, _upcomingSocialSetChange) ?? 0)
    });
    const amountExtraUsersText = this.intl.t('checkout.success_modal_update.amount_extra_users', {
      amount: Math.abs(_classPrivateFieldGet(this, _upcomingUserChange) ?? 0)
    });
    return [{
      changesCopy: aiCreditsDowngradeText,
      isRemoving: _classPrivateFieldGet(this, _isAiCreditsDowngrade)
    }, {
      changesCopy: amountExtraUsersText,
      isRemoving: _classPrivateFieldGet(this, _isUserDowngrade)
    }, {
      changesCopy: amountExtraSocialSetsText,
      isRemoving: _classPrivateFieldGet(this, _isSocialSetDowngrade)
    }].filter(addon => addon.isRemoving).map(item => item.changesCopy);
  }
  function _get_addonUpgradeMap() {
    const aiCreditsUpgradeText = this.intl.t('checkout.success_modal_update.amount_extra_ai_credits', {
      amount: Math.abs(_classPrivateFieldGet(this, _upcomingAiCreditsChange) ?? 0)
    });
    const amountExtraSocialSetsText = this.intl.t('checkout.success_modal_update.amount_extra_social_sets', {
      amount: Math.abs(_classPrivateFieldGet(this, _upcomingSocialSetChange) ?? 0)
    });
    const amountExtraUsersText = this.intl.t('checkout.success_modal_update.amount_extra_users', {
      amount: Math.abs(_classPrivateFieldGet(this, _upcomingUserChange) ?? 0)
    });
    return [{
      changesCopy: aiCreditsUpgradeText,
      isAdding: _classPrivateFieldGet(this, _isAiCreditsUpgrade)
    }, {
      changesCopy: amountExtraUsersText,
      isAdding: _classPrivateFieldGet(this, _isUserUpgrade)
    }, {
      changesCopy: amountExtraSocialSetsText,
      isAdding: _classPrivateFieldGet(this, _isSocialSetUpgrade)
    }].filter(addon => addon.isAdding).map(item => item.changesCopy);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CheckoutSuccessModalComponent);
});